import React, { Component } from 'react';
import NewsItem from './NewsItem';
import Spinner from './Spinner';
import PropTypes from 'prop-types'
import InfiniteScroll from "react-infinite-scroll-component";

export default class News extends Component {
  // articles = [
  //   {
  //     "source": {
  //       "id": "bbc-sport",
  //       "name": "BBC Sport"
  //     },
  //     "author": null,
  //     "title": "Champions Trophy LIVE: Bangladesh vs New Zealand, Rawalpindi – cricket score, radio commentary, video highlights & updates",
  //     "description": "Bangladesh face New Zealand in the Champions in Rawalpindi - follow live cricket scores, text updates, in-play video clips and radio commentary",
  //     "url": "http://www.bbc.co.uk/sport/cricket/live/clykpkezv5pt",
  //     "urlToImage": "https://static.files.bbci.co.uk/ws/simorgh-assets/public/sport/images/metadata/poster-1024x576.png",
  //     "publishedAt": "2025-02-24T08:52:19.4552015Z",
  //     "content": "Bangladesh: Najmul Hossain Shanto (c), Tanzid Hasan Tamim, Mehidy Hasan Miraz, Tawhid Hridoy, Mushfiqur Rahim (wk), Mahmudullah, Jaker Ali, Rishad Hossain, Taskin Ahmed, Mustafizur Rahman, Nahid Rana… [+188 chars]"
  //   },
  //   {
  //     "source": {
  //       "id": "espn-cric-info",
  //       "name": "ESPN Cric Info"
  //     },
  //     "author": null,
  //     "title": "PCB hands Umar Akmal three-year ban from all cricket | ESPNcricinfo.com",
  //     "description": "Penalty after the batsman pleaded guilty to not reporting corrupt approaches | ESPNcricinfo.com",
  //     "url": "http://www.espncricinfo.com/story/_/id/29103103/pcb-hands-umar-akmal-three-year-ban-all-cricket",
  //     "urlToImage": "https://a4.espncdn.com/combiner/i?img=%2Fi%2Fcricket%2Fcricinfo%2F1099495_800x450.jpg",
  //     "publishedAt": "2020-04-27T11:41:47Z",
  //     "content": "Umar Akmal's troubled cricket career has hit its biggest roadblock yet, with the PCB handing him a ban from all representative cricket for three years after he pleaded guilty of failing to report det… [+1506 chars]"
  //   },
  //   {
  //     "source": {
  //       "id": "espn-cric-info",
  //       "name": "ESPN Cric Info"
  //     },
  //     "author": null,
  //     "title": "What we learned from watching the 1992 World Cup final in full again | ESPNcricinfo.com",
  //     "description": "Wides, lbw calls, swing - plenty of things were different in white-ball cricket back then | ESPNcricinfo.com",
  //     "url": "http://www.espncricinfo.com/story/_/id/28970907/learned-watching-1992-world-cup-final-full-again",
  //     "urlToImage": "https://a4.espncdn.com/combiner/i?img=%2Fi%2Fcricket%2Fcricinfo%2F1219926_1296x729.jpg",
  //     "publishedAt": "2020-03-30T15:26:05Z",
  //     "content": "Last week, we at ESPNcricinfo did something we have been thinking of doing for eight years now: pretend-live ball-by-ball commentary for a classic cricket match. We knew the result, yes, but we tried… [+6823 chars]"
  //   }
  // ]

  static defaultProps = {
    country: 'us',
    pageSize: 6,
    category: 'general',
  };

  static propTypes = {
    country: PropTypes.string,
    pageSize: PropTypes.number,
    category: PropTypes.string,
  }

  capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }


  constructor(props) {
    super(props);
    // console.log("Hello i am a constructor from news components !")
    this.state = {
      // articles: this.articles,
      articles: [],
      loading: true,
      page: 1,
      totalResults: 0
    };
    document.title = `${this.capitalizeFirstLetter(this.props.category)} - NewsPtuCoder`;
  };

  // async updateNews() {
  //   // console.log("update Button");
  //   let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=a7faa491732c451d9e1e17dbfedb3b66&page=${this.state.page}&pageSize=${this.props.pageSize}`;
  //   this.setState({ loading: true });
  //   let data = await fetch(url);
  //   let parsedData = await data.json();
  //   // console.log(parsedData);
  //   this.setState({
  //     articles: parsedData.articles,
  //     totalResults: parsedData.totalResults,
  //     loading: false
  //   });
  // }

  async updateNews() {
    this.props.setProgress(10);
    let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=${this.props.apiKey}&page=${this.state.page}&pageSize=${this.props.pageSize}`;
    this.setState({ loading: true });

    let data = await fetch(url);
    this.props.setProgress(30);
    let parsedData = await data.json();
    this.props.setProgress(60);

    if (parsedData && parsedData.articles) {
      this.setState({
        articles: parsedData.articles.filter(article => article), // Ensure valid data
        totalResults: parsedData.totalResults,
        loading: false
      });
    } else {
      this.setState({ articles: [], loading: false });
    }
    this.props.setProgress(100);
  }



  async componentDidMount() {
    // // console.log("component did mount is running !");
    // let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=a7faa491732c451d9e1e17dbfedb3b66&page=1&pageSize=${this.props.pageSize}`;
    // this.setState({ loading: true });
    // let data = await fetch(url);
    // let parsedData = await data.json()
    // // console.log(parsedData);
    // this.setState({
    //   articles: parsedData.articles,
    //   totalResults: parsedData.totalResults,
    //   loading: false
    // });

    this.updateNews();
  }

  handlePrevClick = async () => {
    // // console.log("Previous Button");
    // let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=a7faa491732c451d9e1e17dbfedb3b66&page=${this.state.page - 1}&pageSize=${this.props.pageSize}`;
    // this.setState({ loading: true });
    // let data = await fetch(url);
    // let parsedData = await data.json()
    // // console.log(parsedData);
    // // this.setState({ articles: parsedData.articles });

    // this.setState({
    //   page: this.state.page - 1,
    //   articles: parsedData.articles,
    //   loading: false
    // })

    this.setState({ page: this.state.page - 1 });
    this.updateNews();

  }

  handleNextClick = async () => {
    // console.log("Next Button");
    // if (!((this.state.page + 1 > Math.ceil(this.state.totalResults / this.props.pageSize)))) {
    //   let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=a7faa491732c451d9e1e17dbfedb3b66&page=${this.state.page + 1}&pageSize=${this.props.pageSize}`;
    //   this.setState({ loading: true });
    //   let data = await fetch(url);
    //   let parsedData = await data.json()
    //   // console.log(parsedData);
    //   // this.setState({ articles: parsedData.articles });
    //   this.setState({
    //     page: this.state.page + 1,
    //     articles: parsedData.articles,
    //     loading: false
    //   })
    // }

    this.setState({ page: this.state.page + 1 });
    this.updateNews();

  }

  fetchMoreData = async () => {
    // this.setState({ page: this.state.page + 1 });
    const url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=${this.props.apiKey}&page=${this.state.page+1}&pageSize=${this.props.pageSize}`;
    this.setState({ page: this.state.page + 1 });
    // this.setState({ loading: true });
    let data = await fetch(url);
    let parsedData = await data.json()
    // console.log(parsedData);
    this.setState({
      articles: this.state.articles.concat(parsedData.articles),
      totalResults: parsedData.totalResults
      // loading: false
    });
  };


  render() {
    // console.log("Render is running !")
    return (
      <>
        <div className='container my-4'>
          <h1 className='text-center' style={{ margin: '10px 0px', marginTop: "60px" }}>NewsPtuCoder - Top {this.capitalizeFirstLetter(this.props.category)} Headlines</h1>
          {this.state.loading && <Spinner />}

          {/* <InfiniteScroll
            dataLength={this.state.articles.length}
            next={this.fetchMoreData}
            hasMore={this.state.articles.length !== this.state.totalResults}
            // loader={<h4>{this.state.loading && <Spinner />} </h4>}
            loader={<Spinner />}
          > */}
          <InfiniteScroll
            dataLength={this.state.articles ? this.state.articles.length : 0} // Safe check
            next={this.fetchMoreData}
            hasMore={this.state.articles && this.state.articles.length < this.state.totalResults}
            loader={<Spinner />}
          >



            <div className="container">

              <div className="row">
                {/* {
                  // !this.state.loading &&
                  this.state.articles.map((element) => {
                    return (<div className='col-md-4' key={element.url}>
                      <NewsItem title={element.title ? element.title.slice(0, 45) : " "} description={element.description ? element.description.slice(0, 87) + "..." : ""} imageUrl={element.urlToImage}
                        newsUrl={element.url} author={element.author} date={element.publishedAt}
                        source={element.source.name} />
                    </div>
                    );
                  })} */}

                {this.state.articles && this.state.articles.length > 0 ? (
                  this.state.articles.map((element) => (
                    <div className='col-md-4' key={element.url}>
                      <NewsItem
                        title={element.title ? element.title.slice(0, 45) : " "}
                        description={element.description ? element.description.slice(0, 87) + "..." : ""}
                        imageUrl={element.urlToImage}
                        newsUrl={element.url}
                        author={element.author}
                        date={element.publishedAt}
                        source={element.source.name}
                      />
                    </div>
                  ))
                ) : (
                  <h3 className="text-center">No News Available</h3>
                )}



              </div>

            </div>

          </InfiniteScroll>
          {/* <div className="container d-flex justify-content-between ">
          <button disabled={this.state.page <= 1} type="button" className="btn btn-sm btn-dark" onClick={this.handlePrevClick}>&larr; Previous</button>
          <button disabled={((this.state.page + 1 > Math.ceil(this.state.totalResults / this.props.pageSize)))} type="button" className="btn  btn-sm  btn-dark" onClick={this.handleNextClick}> Next &rarr;</button>
           </div> */}
        </div>

      </>
    );
  }
}
